import { UseMutateFunction } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { useState } from 'react';

import {
  HostingSiteAddV2Body,
  HostingSiteAddV2200,
} from '@newfold/huapi-js/src/index.schemas';

import useAccount from '~/hooks/useAccount';
import useHostingNavigate from '~/hooks/useHostingNavigate';

import { AddSiteFormDataTypes } from '..';
import DomainForm from './DomainForm';
import BtnGroup from './MultiStepCard/BtnGroup';

type ConnectDomainPropOptions = {
  formData?: AddSiteFormDataTypes;
  setFormData?: (state: AddSiteFormDataTypes | any) => void;
  createWebsite?: UseMutateFunction<
    AxiosResponse<HostingSiteAddV2200, any>,
    any,
    { hostingId: string; data: HostingSiteAddV2Body },
    void
  >;
  changeLoading?: boolean;
  isSiteAddPending?: boolean;
};

const ConnectDomain = ({
  formData = {},
  setFormData = () => {},
  createWebsite = () => {},
  changeLoading = false,
  isSiteAddPending = false,
}: ConnectDomainPropOptions) => {
  const { id: hostingId } = useAccount();
  const hostingNavigate = useHostingNavigate();

  const [error, setError] = useState(false);
  const [value, setValue] = useState(formData?.domain);

  // preventPath will change when a path is entered/removed by the user (see DomainForm logic)
  // It applies to basic hosting and generic site cases
  const [preventPath, setPreventPath] = useState(false);

  const handleSkipBtn = () => {
    handleContinueBtn({
      ...formData,
      domain: '',
      path: '',
    });
  };

  const handleContinueBtn = (updatedFormData?: AddSiteFormDataTypes) => {
    const data = updatedFormData ?? formData;
    createWebsite({
      hostingId,
      data: {
        title: data.siteName,
        domain: data.domain,
        path: data.path,
        subtype: data.subtype!,
      },
    });
  };

  const handleCloseInstallModal = () => hostingNavigate();

  const disableCTA = () =>
    changeLoading ||
    preventPath ||
    (formData.domain === '' && !formData.autoGeneration) ||
    (error && value !== '');
  return (
    <DomainForm
      formData={formData}
      setFormData={setFormData}
      preventPath={preventPath}
      setPreventPath={setPreventPath}
      error={error}
      setError={setError}
      value={value}
      setValue={setValue}
    >
      <BtnGroup
        hasSkipBtn
        onSkipHandler={handleSkipBtn}
        onClickHandler={() => handleContinueBtn()}
        onCloseHandler={handleCloseInstallModal}
        disabled={disableCTA()}
        loading={changeLoading}
        domainChangeLoading={isSiteAddPending}
        type={formData.subtype}
      />
    </DomainForm>
  );
};

export default ConnectDomain;
